module.exports = __webpack_public_path__ + "media/images/category_icons/category_icon_9-c7679fb8eeb8ed1579b2e20902aac72f.svg";